import { AsyncPipe, KeyValuePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { FilterOptions } from './interfaces/filter-options';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, KeyValuePipe],
})
export class FilterComponent {
  @Input({ required: true })
  options!: FilterOptions<any>;

  @Input({ required: true })
  value$!: Observable<string>;

  @Output()
  valueChanged = new EventEmitter<string>();

  onSelect(value: string): void {
    this.valueChanged.emit(value);
  }
}
